import { Card } from "@/components/ui/card";
import { Smartphone, Radio } from "lucide-react";

// Placeholder store links. Replace with real App Store / Play Store URLs
// once the mobile app is published.
const APP_STORE_URL = "#app-store-coming-soon";
const PLAY_STORE_URL = "#play-store-coming-soon";

// Official-style Apple logo mark (used in the "Download on the App Store"
// badge). Monochrome, uses `currentColor` so it inherits the pill text color.
const AppleMark = (props) => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M17.564 13.156c-.03-2.993 2.44-4.43 2.552-4.5-1.391-2.031-3.556-2.31-4.325-2.345-1.843-.187-3.595 1.084-4.53 1.084-.934 0-2.374-1.056-3.906-1.027-2.012.03-3.864 1.167-4.9 2.964-2.089 3.617-.534 8.973 1.5 11.914.998 1.44 2.19 3.056 3.753 2.998 1.509-.06 2.077-.976 3.9-.976 1.822 0 2.335.976 3.925.943 1.619-.028 2.645-1.467 3.636-2.912 1.147-1.669 1.619-3.288 1.648-3.37-.036-.015-3.161-1.213-3.253-4.773zM14.7 4.6c.823-1.004 1.38-2.397 1.228-3.782-1.187.049-2.628.8-3.48 1.802-.765.891-1.433 2.313-1.253 3.675 1.325.103 2.68-.677 3.505-1.695z" />
  </svg>
);

// Official-style Google Play triangle logo (4 colored facets).
const GooglePlayMark = (props) => (
  <svg viewBox="0 0 512 512" width="20" height="20" aria-hidden="true" {...props}>
    <path d="M325.3 234.3L104.6 13 420.1 189.7z" fill="#00f076" />
    <path d="M104.6 13c-6.3 2.8-10.6 9-10.6 17.2v451.6c0 8.1 4.3 14.4 10.6 17.2L325.3 277.7 104.6 13z" fill="#00c3ff" />
    <path d="M420.1 322.3l-94.8-52L104.6 499l315.5-176.7z" fill="#ff3131" />
    <path d="M420.1 189.7l-94.8 52 94.8 52 76.5-42.6c17.3-9.6 17.3-33.9 0-43.5l-76.5-42.6z" fill="#ffde3a" />
  </svg>
);

export default function SimHubDownloadAppCard() {
  return (
    <Card className="border-border bg-card p-5" data-testid="simhub-download-app-card">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-md bg-primary/15 text-primary">
            <Smartphone className="h-6 w-6" />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h2 className="font-display text-lg font-bold">Pair SimHub from the app</h2>
            </div>
            <p className="mt-1 text-sm text-muted-foreground">
              SimHub pairing lives in the Sim Racing Connected mobile app. Install the app, open the SimHub tab, and the live telemetry will stream here automatically.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-4 flex flex-wrap gap-3" data-testid="simhub-store-links">
        {/* Apple App Store badge — matches Apple's official "Download on the App Store" pill */}
        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2.5 rounded-lg bg-black px-4 py-2 text-white transition-opacity hover:opacity-90"
          data-testid="simhub-app-store-link"
          aria-label="Download on the App Store"
        >
          <AppleMark />
          <span className="flex flex-col leading-tight">
            <span className="text-[10px] font-normal">Download on the</span>
            <span className="font-semibold text-lg leading-none">App Store</span>
          </span>
        </a>

        {/* Google Play badge — matches Google's official "Get it on Google Play" pill */}
        <a
          href={PLAY_STORE_URL}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2.5 rounded-lg bg-black px-4 py-2 text-white transition-opacity hover:opacity-90"
          data-testid="simhub-play-store-link"
          aria-label="Get it on Google Play"
        >
          <GooglePlayMark />
          <span className="flex flex-col leading-tight">
            <span className="text-[10px] font-normal">GET IT ON</span>
            <span className="font-semibold text-lg leading-none">Google Play</span>
          </span>
        </a>
      </div>

      <div className="mt-4 flex items-start gap-2 rounded-md border border-border bg-secondary/40 p-3 text-xs text-muted-foreground">
        <Radio className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-primary" />
        <p>
          Once the mobile app is open and connected to SimHub, this page shows the live dashboard automatically.
        </p>
      </div>
    </Card>
  );
}
